import { observer } from 'mobx-react';
import { NotTranslated, T } from '../../../Translations';
import FlashError from '../../FlashMessage/FlashError';
import Loader from '../../Loader';
import Overview from './Overview';
import { ProductLicensesStore } from './Store';

interface Props {
  store: ProductLicensesStore;
}

function Display({ store }: Props) {
  switch (store.state.kind) {
    case 'waiting':
    case 'loading':
      return <Loader />;
    case 'loading-error':
      return (
        <FlashError>
          <T kind="Error Loading." /> <NotTranslated text={store.state.error.kind} />
        </FlashError>
      );
    case 'ready':
      return <Overview state={store.state} />;
  }
}

export default observer(Display);
